import lspSubHeaderTemplate from './lsp-page-sub-header.html';

class LspPageSubHeaderController {
  constructor(gettextCatalog) {
    this.translatedText = gettextCatalog.getString(this.text);
  }
}

LspPageSubHeaderController.$inject = ['gettextCatalog'];

export default class LspPageSubHeaderComponent {
  constructor() {
    this.bindings = {
      class: '<',
      text: '<',
    };

    this.controller = LspPageSubHeaderController;
    this.template = lspSubHeaderTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-page-sub-header/lsp-page-sub-header-component.js